/**
 * RegisterPage Component
 *
 * Renders the multi-step onboarding wizard.
 */

import React from 'react';
import { OnboardingPage } from './OnboardingPage';

export const RegisterPage: React.FC = () => {
  return <OnboardingPage />;
};

export default RegisterPage;
